export class SubscriptionPlanPrice {
	public planId: number
	public productId: number
	public currency: string
	public price: number

	constructor(data: {
		planId: number
		productId: number
		currency: string
		price: number
	}) {
		this.planId = data.planId
		this.productId = data.productId
		this.currency = data.currency
		this.price = data.price
	}

	static create(data: Partial<SubscriptionPlanPrice>) {
		const defaultData = {
			planId: 0,
			productId: 0,
			currency: 'USD',
			price: 0,
		}

		return new SubscriptionPlanPrice({ ...defaultData, ...data })
	}
}
